import { __assign, __extends } from "tslib";
import React from 'react';
function withCssFilter(WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.shouldRenderCssFilters = function () {
                var _a = _this.props.styles, backgroundGrayscaleFilter = _a.backgroundGrayscaleFilter, backgroundBlurFilter = _a.backgroundBlurFilter;
                return backgroundBlurFilter > 1 || backgroundGrayscaleFilter;
            };
            _this.renderStyleTagBackgroundFilters = function () {
                var renderBackgroundFilterElement = _this.props.backgroundFilterElementSelector;
                var _a = _this.props.styles, backgroundGrayscaleFilter = _a.backgroundGrayscaleFilter, backgroundBlurFilter = _a.backgroundBlurFilter;
                var grayScaleValue = backgroundGrayscaleFilter ? '1' : '0';
                var cssFilters = "blur(".concat(backgroundBlurFilter, "px) grayscale(").concat(grayScaleValue, ")");
                return (React.createElement("style", null, "".concat(renderBackgroundFilterElement, " {\n              filter: ").concat(props.fullscreenAnimating ? 'none' : cssFilters, ";\n              transition: filter 0.8s ease;\n            }")));
            };
            _this.state = {
                isMounted: false
            };
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            this.setState({ isMounted: true });
        };
        class_1.prototype.render = function () {
            if (!this.shouldRenderCssFilters() || !this.state.isMounted) {
                return React.createElement(WrappedComponent, __assign({}, this.props));
            }
            return (React.createElement("div", { className: 'pro-fullscreen-renderer-wrapper' },
                React.createElement(WrappedComponent, __assign({}, this.props)),
                this.renderStyleTagBackgroundFilters()));
        };
        return class_1;
    }(React.Component));
}
export default withCssFilter;
//# sourceMappingURL=withCssFilter.js.map